import { render, staticRenderFns } from "./BasketItem.vue?vue&type=template&id=6cf25822&scoped=true&"
import script from "./BasketItem.vue?vue&type=script&lang=js&"
export * from "./BasketItem.vue?vue&type=script&lang=js&"
import style0 from "./BasketItem.vue?vue&type=style&index=0&id=6cf25822&scoped=true&lang=css&"
import style1 from "./BasketItem.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cf25822",
  null
  
)

export default component.exports